const DeviceType = {
  MOBILE: 'mobile',
  LAPTOP: 'laptop',
  DESKTOP: 'desktop',
  TABLET: 'tablet',
};

module.exports = DeviceType;
